import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import { tags } from '../../consts/Tags.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import SoundManager from '../../prefabs/SoundManager.js';
import AbstractScene from '../AbstractScene.js';

export default class DebutChapitre3 extends AbstractScene {

    constructor() {
        super({
            key: "DebutChapitre3"
        })
    }
    init(data){
        this._init(data);   

        this.soundManager = new SoundManager();
        this.soundManager.stopAllLoops()
        this.soundManager.playAudio('ImmovableMountain');
    }   

    preload() {
        this._preload();
    }

    create() {
        // Ajout fond
        let background = this.add.image(0, 0, 'Chapitre3_transition_background').setOrigin(0);

        // Ajout num chapitre
        let numChapitre = this.add.text(660, 180, 'CHAPITRE 3',{
            fontSize: '18px',
            fontFamily: FONTS.Inter18Light,
            color: Colors.Text.White,
            letterSpacing:3
        }).setOrigin(0)
        numChapitre.setAlpha(0)

        // Ajout titre
        let titre1 = this.add.image(607, 110, 'Chapitre3_transition_titre').setOrigin(0)
        titre1.setAlpha(0)


        // Ajout pop up

        // Ajout transitions

        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                rect.destroy();
                
            }
        })

        this.tweens.add({
            targets: numChapitre,
            alpha: 1,
            delay: 200,
            duration: 200,
        })

        titre1.x -=50
        this.tweens.add({
            targets: titre1,
            alpha: 1,
            x: titre1.x + 50,
            delay: 400,
            duration: 400,
        })

        this.time.addEvent({
            delay: 1000,
            callback: () => {
                this.addPopUp()
            }
        })

    }

    addPopUp(){

        this.popupAide = new PopUpBlue(this, this.width/2, 828, 662, 367)
        this.popupAide.depth = 1001

        const txt ="Le laboratoire de Kensei Therapeutics se trouve juste à côté de Kyoto. C’est la première fois que je viens dans cette ville et les cerisiers en fleurs lui donnent un charme presque irréel.\n<class=\"Inter28BoldItalic\">J’espère retrouver la trace de Leïla. Le voyage a été long et fatigant…</class>"
        let textElmt = this.add.rexTagText(0, 0, txt, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'left',
            wordWrap: { width: 550 },
            lineSpacing: 8,
            tags: tags
        }).setOrigin(0.5, 0)

        this.popupAide.addElementToBody(textElmt, 40)

        let button = new ButtonRounded(this, 0, 0, {
            text: "Démarrer le chapitre 3",
            color: Colors.Elmt.White,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue
        })
        this.popupAide.addButtonToBody(button)
        button.setClickFunction( () => {
            this.animOut()
        })

        this.popupAide.animIn()
    }

    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Chapitre3_0")
            }
        })
    }
}